import { Form, Input, InputNumber, Card, Row, Col, Switch, Tooltip, Button } from "antd";
import { UploadOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { FormInstance } from "antd/lib/form";

interface BasicInfoCardProps {
    form: FormInstance;
    itemName: string;
    handleItemNameChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    generateItemCode: () => { itemCode: string; barcode: string };
}

export const BasicInfoCard = ({ form, itemName, handleItemNameChange, generateItemCode }: BasicInfoCardProps) => {
    return (
        <Card title="Basic Information" style={{ marginBottom: 16 }}>
            <Row gutter={16}>
                <Col span="8">
                    <Form.Item
                        label={
                            <span>
                                Item Code
                                <Tooltip title="Auto-generated based on item name">
                                    <InfoCircleOutlined style={{ marginLeft: 8 }} />
                                </Tooltip>
                            </span>
                        }
                        name="ItemCode"
                        rules={[{ required: true, message: "Item code is required" }]}
                    >
                        <Input
                            placeholder="Auto-generated"
                            readOnly
                            suffix={
                                <Tooltip title="Regenerate code">
                                    <Button
                                        icon={<UploadOutlined />}
                                        type="text"
                                        size="small"
                                        onClick={() => {
                                            const generated = generateItemCode();
                                            form.setFieldsValue({
                                                ItemCode: generated.itemCode,
                                                Barcode: generated.barcode
                                            });
                                        }}
                                    />
                                </Tooltip>
                            }
                            style={{ backgroundColor: '#f5f5f5' }}
                        />
                    </Form.Item>
                </Col>

                <Col span="8">
                <Form.Item
                        label="Item Name"
                        name="ItemName"
                        rules={[{ required: true, message: "Item name is required" }]}
                    >
                        <Input
                            placeholder="Enter item name"
                            onChange={handleItemNameChange}
                        />
                    </Form.Item>
                    
                </Col>

                <Col span="8">
                    <Form.Item
                        label="HSCode"
                        name="ItemClassificationCode"
                        rules={[{ required: true, message: "Classification code is required" }]}
                        maxLength={8}
                        minLength={8}
                    >
                        <Input placeholder="Enter classification code" />
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={16}>
                <Col span="12">
                <Form.Item
                        label="Item Description"
                        name="ItemTypeCode"
                        rules={[{ required: true, message: "Item description is required" }]}
                    >
                        <Input placeholder="Enter item description" />
                    </Form.Item>
                </Col>

                <Col span="12">
                    <Form.Item
                        label="Barcode"
                        name="Barcode"
                    >
                        <Input
                            placeholder="Enter barcode"
                        />
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={16}>
                <Col span="12">
                    <Form.Item
                        label="Safety Quantity"
                        name="SafetyQuantity"
                        tooltip="Minimum stock level before reorder is recommended"
                    >
                        <InputNumber
                            min={0}
                            style={{ width: '100%' }}
                            placeholder="Enter safety stock level"
                        />
                    </Form.Item>
                </Col>

                <Col span="12">
                    <Form.Item
                        label="Is Active"
                        name="IsActive"
                        valuePropName="checked"
                    >
                        <Switch defaultChecked />
                    </Form.Item>
                </Col>
            </Row>

            <Form.Item
                label="Additional Information"
                name="AdditionalInformation"
            >
                <Input.TextArea rows={3} placeholder="Enter additional details about the item" />
            </Form.Item>
        </Card>
    );
}; 